import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskedLine } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();

  return (
  <footer data-testid="site-footer" className="border-t border-[#262626] bg-[#0A0A0A]">
    <div className="mx-auto max-w-7xl px-6 py-24 md:px-12">
      <h2 className="font-syne font-extrabold uppercase leading-[0.9] tracking-tighter text-[#F2F2F2]">
        <MaskedLine innerClassName="text-[clamp(2.5rem,8vw,6rem)]">Ny hjemmeside</MaskedLine>
        <MaskedLine delay={0.12} innerClassName="text-[clamp(2.5rem,8vw,6rem)] text-[#FF3333]">
          NU.
        </MaskedLine>
      </h2>
      <div className="mt-16 flex flex-col justify-between gap-10 border-t border-[#262626] pt-10 md:flex-row md:items-center">
        <p className="text-sm text-[#A3A3A3]">{t("footer.copy")}</p>
        <div className="flex items-center gap-8">
          <a
            data-testid="footer-email-link"
            href="mailto:gertkonge@gmail.com"
            className="group flex items-center gap-2 text-sm text-[#F2F2F2] transition-colors duration-300 hover:text-[#FF3333]"
          >
            gertkonge@gmail.com
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <Link
            data-testid="footer-admin-link"
            to="/admin"
            className="text-sm text-[#555] transition-colors duration-300 hover:text-[#A3A3A3]"
          >
            {t("footer.admin")}
          </Link>
        </div>
      </div>
    </div>
  </footer>
  );
};
